import { render, staticRenderFns } from "./WatchlistButton.vue?vue&type=template&id=5a7bd852&scoped=true"
import script from "./WatchlistButton.vue?vue&type=script&lang=js"
export * from "./WatchlistButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7bd852",
  null
  
)

export default component.exports